import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Container } from '@abb/uikit';
import React from 'react';
export function ConditionalContainer(param) {
    let { children, condition, boxProps, containerProps } = param;
    if (condition) {
        return /*#__PURE__*/ _jsx(Box, {
            width: "100%",
            bg: "red",
            ...boxProps,
            children: /*#__PURE__*/ _jsx(Container, {
                maxWidth: "1200px",
                px: {
                    base: 4,
                    lg: 2,
                    xl: 0
                },
                ...containerProps,
                children: children
            })
        });
    }
    return children;
}
